// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/radio-group","root":"radio-group-m__root__3VCTl","legend":"radio-group-m__legend__ZiCRP"};